<!-- stylized a4 page in portrait format. the hinted text lines make the box read as a
     document page, so the width and alignment of the image become comprehensible -->
<div class="qa-image-display-preview-page">
  <div class="qa-image-display-preview-line"></div>
  <div class="qa-image-display-preview-line qa-image-display-preview-line-short"></div>

  <img
    *ngIf="imageUrl; else imageDisplayPreviewPlaceholder"
    class="qa-image-display-preview-image"
    [src]="imageUrl"
    [ngStyle]="getImageStyle()"
  />

  <ng-template #imageDisplayPreviewPlaceholder>
    <div class="qa-image-display-preview-placeholder" [ngStyle]="getImageStyle()">
      <i class="fa fa-picture-o"></i>
    </div>
  </ng-template>

  <div class="qa-image-display-preview-line"></div>
  <div class="qa-image-display-preview-line qa-image-display-preview-line-short"></div>
</div>
